export default __webpack_public_path__ + "static/media/sample.9c08c564.csv";